import Home from './pages/Home.vue'
import Ingredients from './pages/Ingredients.vue'

export const routes = [
  { path: "/", component: Home },
  { path: "/ingredients", component: Ingredients },
];
